// extracted by mini-css-extract-plugin
module.exports = {"subscription-collection-wrapper":"_2F_Mz","summary":"_3yXEF","subscription-collection":"_1Lbdu"};